export const language = {
    "Custom Design": "Design Personnalisé",
    "Cancel": "Annuler",
    "Update": "Mettre à jour",
    "Save": "Enregistrer",
}